import { render, staticRenderFns } from "./pledgeGasDaily.vue?vue&type=template&id=ca0a6fea&scoped=true&"
import script from "./pledgeGasDaily.vue?vue&type=script&lang=js&"
export * from "./pledgeGasDaily.vue?vue&type=script&lang=js&"
import style0 from "./pledgeGasDaily.vue?vue&type=style&index=0&id=ca0a6fea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0a6fea",
  null
  
)

export default component.exports